// src/components/ConnectionSuccessNotification/ConnectionSuccessNotificationWrapper.js
import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import ConnectionSuccessNotification from './ConnectionSuccessNotification';

/**
 * Wrapper component for ConnectionSuccessNotification that provides methods
 * to show and hide the notification from external components
 */
const ConnectionSuccessNotificationWrapper = forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [dappInfo, setDappInfo] = useState({
    name: '',
    url: ''
  });
  
  const hideTimeoutRef = useRef(null);
  
  // Expose methods to parent components via ref
  useImperativeHandle(ref, () => ({
    // Show success notification with dApp info
    showSuccess: (dappName, dappUrl) => {
      // Clear any existing timeout
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
      
      // Set dApp info
      setDappInfo({
        name: dappName || '',
        url: dappUrl || ''
      });
      
      // Show notification
      setIsVisible(true);
    },
    
    // Hide notification programmatically
    hide: () => {
      setIsVisible(false);
    }
  }));
  
  // Handle notification close
  const handleClose = () => {
    setIsVisible(false);
  };
  
  return (
    <ConnectionSuccessNotification
      isVisible={isVisible}
      dappName={dappInfo.name}
      dappUrl={dappInfo.url}
      onClose={handleClose}
    />
  );
});

ConnectionSuccessNotificationWrapper.displayName = 'ConnectionSuccessNotificationWrapper';

export default ConnectionSuccessNotificationWrapper;